const en = {
    noMessages: 'You have no messages',
  }
  
  const rus = {
    noMessages: 'У вас нет сообщений',
  }
  
  const hebrew = {
    noMessages: 'אין לך הודעות',
  }
  
  const messages = { en, rus, hebrew };
  
  export default messages;